import React from 'react'
import { UnitCreators } from '@leverege/api-attributes'

import BaseAttributeEditor from './BaseAttributeEditor'
import IntAttributeEditor from './IntAttributeEditor'
import BooleanAttributeEditor from './BooleanAttributeEditor'
import NumberAttributeEditor from './NumberAttributeEditor'
import UnitAttributeEditor from './UnitAttributeEditor'
import PercentAttributeEditor from './PercentAttributeEditor'
import StringAttributeEditor from './StringAttributeEditor'
import TimestampAttributeEditor from './TimestampAttributeEditor'
import RelationshipAttributeEditor from './RelationshipAttributeEditor'
import ParentRelationshipAttributeEditor from './ParentRelationshipAttributeEditor'
import EnumAttributeEditor from './EnumAttributeEditor'
import ResourceEnumAttributeEditor from './ResourceEnumAttributeEditor'

function createEditor( attribute, blueprint, props ) {
  props = props || {}
  props.attribute = attribute
  props.blueprint = blueprint

  switch ( attribute.type ) {
    case 'boolean': return <BooleanAttributeEditor {...props} />
    case 'int': return <IntAttributeEditor {...props} />
    case 'number': return <NumberAttributeEditor {...props} />
    case 'percent': return <PercentAttributeEditor {...props} />
    case 'string': return <StringAttributeEditor {...props} />
    case 'timestamp': return <TimestampAttributeEditor {...props} />
    case 'relationship': return <RelationshipAttributeEditor {...props} />
    case 'parentRelationship': return <ParentRelationshipAttributeEditor {...props} />
    case 'enum': return <EnumAttributeEditor {...props} />
    case 'resourceEnum': return <ResourceEnumAttributeEditor {...props} />
    default: {
      const uTypes = UnitCreators.getCreators()
      for ( let n = 0; n < uTypes.length; n++ ) {
        if ( uTypes[n].typeName() === attribute.type ) {
          return <UnitAttributeEditor {...props} />
        }
      }
    }
  }
  return <BaseAttributeEditor {...props} /> 
}

module.exports = {
  createEditor
}
